export const ACC_COOCKIE = 'acc_info'
export const EVENT_TOGGLE_TOOLBAR = 'event_toggle_toolbar'
export const EVENT_ON_ACC_READY = 'event_acc_ready'
export const EVENT_KEYBOARD_NAV_OPENED = 'event_keyboard_nav_load'
export const EVENT_KEYBOARD_ESC = 'event_keyboard_esc'
export const EVENT_HIDE_ACC = 'event_acc_hide'
export const EVENT_TOGGLE_ANIMATION = 'event_toggle_animations'

export const EVENT_ADD_CONTRAST_DARK = 'event_add_contast_dark'
export const EVENT_ADD_CONTRAST_LIGHT = 'event_add_contast_light'
export const EVENT_ADD_CONTRAST_MONO = 'event_add_contast_mono'

export const BTN_KEYBOARD = 'acc-keyboard'
export const BTN_ANIMATIONS = 'acc-animation'
export const BTN_CONTRAST_MONOCHROME = 'acc-contrast-mono'
export const BTN_CONTRAST_DARK = 'acc-contrast-dark'
export const BTN_CONTRAST_BRIGHT = 'acc-contrast-bright'
export const BTN_TEXT_SMALLER = 'acc-text-down'
export const BTN_TEXT_BIGGER = 'acc-text-up'
export const BTN_TEXT_READABLE = 'acc-font-readable'
export const BTN_CURSOR_W = 'acc-cursor-w'
export const BTN_CURSOR_B = 'acc-cursor-b'
export const BTN_ZOOM = 'acc-zoom'
export const BTN_HIGHLIGHT_LINKS = 'acc-links'
export const BTN_HIGHLIGHT_TITLES = 'acc-titles'
export const BTN_ALTS = 'acc-imgalt'
export const BTN_CLEAR_ALL = 'acc-clearall'
export const BTN_CONTACT = 'acc-contact'
export const BTN_STATEMENT = 'acc-statement'